const APP_NAME     = 'Englishbus';
const DATA_API_KEY = '.data-api';

const $document    = $(document);
const $window      = $(window);
const $html        = $(document.documentElement).removeClass('has-no-js').addClass('has-js');
const $body        = $(document.body);
const $barba       = $('#js-barba-wrapper');

const isMobile     = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
const isIE         = (/Edge|rv:11.0|MSIE 10/i.test(navigator.userAgent));
const isDebug      = !!$html.data('debug');

export { APP_NAME, DATA_API_KEY, $document, $window, $html, $body, $barba, isMobile, isIE, isDebug };
